import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { Collapse, Navbar, NavbarBrand, /*NavbarBrand,*/ NavbarToggler, NavItem, NavLink } from 'reactstrap';
import GlobalAlert from './GlobalAlert';
import './NavMenu.css';
import Logo from '../images/mySage_Gray.jpg'

export const NavMenu = ({alert, businessUnit}) => {

  const {clinicUniqueId} = useParams()

  const homePath = useRef("/" + (clinicUniqueId ?? ''))

  useEffect(() => {
    NavMenu.displayName = NavMenu.name;
  }, [])

  const [collapsed, setCollapsed] = useState(true)

  const toggleNavbar = () => {
    setCollapsed(!collapsed)
  }
  
  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
        <div className='d-flex flex-fill flex-wrap'>
          <NavbarBrand tag={Link} to={homePath.current}>
            {businessUnit && Object.keys(businessUnit).length > 0 && (
              <>
                {businessUnit?.isWhiteLabel ? (
                  <img className="logo" src={businessUnit.buLogoURL} alt={businessUnit.description} />
                ) : (
                  <img className="logo" src={Logo} alt='Sage Healthy RCM&#8482;' />
                )}
              </>
            )}
          </NavbarBrand>
          <NavbarToggler onClick={toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="text-dark" to={homePath.current}>Insurance Verification Request</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink tag={Link} className="text-dark" to="/about">About Us</NavLink>
              </NavItem> */}
            </ul>
          </Collapse>
          <div className='d-block w-100'>
            <GlobalAlert alert={alert} />
          </div>
        </div>

      </Navbar>
    </header>
  );
}

// export class NavMenu extends Component {
//   static displayName = NavMenu.name;


//   constructor (props) {
//     super(props);

//     this.toggleNavbar = this.toggleNavbar.bind(this);
//     this.state = {
//       collapsed: true
//     };
//   }

//   toggleNavbar () {
//     this.setState({
//       collapsed: !this.state.collapsed
//     });
//   }

//   render() {
//     return (
//       <header>
//         <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
//           {/* <NavbarBrand tag={Link} to="/">Brand Needed! (Logo)</NavbarBrand> */}
//           <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
//           <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
//             <ul className="navbar-nav flex-grow">
//               <NavItem>
//                 <NavLink tag={Link} className="text-dark" to="/">Insurance Verification Request</NavLink>
//               </NavItem>
//               {/* <NavItem>
//                 <NavLink tag={Link} className="text-dark" to="/about">About Us</NavLink>
//               </NavItem> */}
//             </ul>
//           </Collapse>
//         </Navbar>
//       </header>
//     );
//   }
// }
